import React, {ReactNode, useMemo} from 'react';
import {MenuProps, MenuState} from '@src/@types/components/Menu';
import AbstractMenu from './AbstractMenu';
import SubMenu from './SubMenu';
import localeConnector from '@src/helpers/localeConnector';
import useSelector from '@src/hooks/useSelector';

class CustomMenu extends AbstractMenu {
    protected subMenuComponent: ReactNode = SubMenu;

    state: MenuState = {
        openedItems: [],
    };
}

const ConnectedMenu = localeConnector(CustomMenu);

export default function Menu(props: MenuProps) {
    const chatUnreadMessagesNumber = useSelector(state => {
        return state.chats.channels.reduce((res, item) => {
            return res + (item.unread_messages_count ?? 0);
        }, 0);
    });

    const items = useMemo(() => {
        if (!chatUnreadMessagesNumber) {
            return props.items;
        }

        const list = [...props.items];
        const index = list.findIndex(item => item.route === 'chat@index');
        if (index !== -1) {
            list[index] = {
                ...list[index],
                badge: {
                    class: 'text-bg-info',
                    label: String(chatUnreadMessagesNumber),
                }
            };
        }

        return list;
    }, [chatUnreadMessagesNumber, props.items]);

    return <ConnectedMenu {...props} items={items}/>;
}
